import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, OnInit } from '@angular/core';
@Component({
  selector: 'app-auth-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-header.component.html',
  styleUrl: './auth-header.component.css',
})
export class AuthHeaderComponent implements OnInit {
  isOnLoginPage: boolean = false;
  constructor(private router: Router, private cdRef: ChangeDetectorRef) {}
  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check if the current route is the login page
        this.isOnLoginPage = this.router.url === '/login';
      }
    });

    // Initialize isOnLoginPage based on the current route
    this.isOnLoginPage = this.router.url === '/login';
  }

  register() {
    this.router.navigate(['/register']);
    this.cdRef.detectChanges();
    localStorage.removeItem('org_info');
  }
  login() {
    // this.activeButton = 'login';
    this.router.navigate(['/login']);
    this.cdRef.detectChanges();
  }
}
